
export * as essay from './essay';
// export * as news from './news';
// export * as novel from './novel';



// WEBPACK FOOTER //
// src/modules/article/registered.js